import { render, staticRenderFns } from "./paperLibrary.vue?vue&type=template&id=2a7d169f&scoped=true&"
import script from "./paperLibrary.vue?vue&type=script&lang=js&"
export * from "./paperLibrary.vue?vue&type=script&lang=js&"
import style0 from "./paperLibrary.vue?vue&type=style&index=0&id=2a7d169f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d169f",
  null
  
)

export default component.exports